<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-10">
            <div class="py-2 px-5 px-md-0">
                <div class="row align-items-center">
                    <div class="col-12 mb-3">
                        <div class="d-flex align-items-center">
                            <div class="mr-3">
                                <app-icon name="map-pin"/>
                            </div>
                            <div>
                                <p class="mb-0">
                                    Address
                                </p>
                                <p class="mb-0 text-muted">
                                    <span class="text-muted">For order:</span> {{ data.order_number }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('name') }}:</span>
                            {{ $optional(data, 'address', 'name') }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('email') }}:</span>
                            {{ $optional(data, 'address', 'email') }}
                        </p>
                    </div>
                    <div class="col-md-5 mb-4 mb-md-0">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('district') }}:</span>
                            {{ $optional(data, 'address', 'district', 'name') }}
                        </p>
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('thana') }}:</span>
                            {{ $optional(data, 'address', 'thana', 'name') }}
                        </p>
                    </div>
                    <div class="col-md-12 mb-4 mb-md-0 p-3">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('delivery_address') }}:</span>
                            {{ $optional(data, 'address', 'address') }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-4 mb-md-0 p-3">
                        <p class="text-right text-md-left mb-1">
                            <span class="text-muted">{{ $t('notes') }}:</span>
                            {{ $optional(data, 'notes') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExpandableOrderDetails",
        props: {
            data: {
                default: function () {
                    return {}
                }
            }
        }
    }
</script>

<style scoped>

</style>